import { visit } from 'unist-util-visit';
import { VFile } from 'vfile';

const sceneHeadingPatterns = [
  // Standard scene headings: INT., EXT., INT./EXT., I/E., EST.
  /^(INT\.\/EXT\.|INT\.|EXT\.|I\/E\.|EST\.)\s+(.*)/i,
  // Forced scene heading: .INT. or .EXT. or .ANYTHING (dot prefix forces)
  /^\.\s*([A-Z0-9][A-Z0-9\s()\-.]*)/,
  // Generic ALL-CAPS scene heading (must be at least 3 chars, no commas or AND)
  /^([A-Z0-9]{2,}[A-Z0-9\s()\-]*[A-Z0-9])(?:[ \t]+-[ \t]+([A-Z0-9\s().\-]+))?$/
];

const isParagraph = (
  node: any
): node is { type: 'paragraph'; children: any[] } =>
  node && node.type === 'paragraph';

const getNodeTextContent = (node: any): string => {
  if (node.type === 'text') {
    return node.value;
  }
  if (node.children) {
    return node.children.map(getNodeTextContent).join('');
  }
  return '';
};

export default function remarkFountainScenes() {
  return (tree: any, file: VFile) => {
    const newChildren: any[] = [];
    let i = 0;

    while (i < tree.children.length) {
      const currentNode = tree.children[i];
      let sceneHeadingText = '';
      let isSceneHeading = false;

      if (isParagraph(currentNode)) {
        const textContent = getNodeTextContent(currentNode);
        for (const pattern of sceneHeadingPatterns) {
          const match = textContent.match(pattern);
          if (match) {
            if (pattern.toString().includes('[A-Z0-9]{2,}')) {
              if (
                textContent.length < 3 ||
                textContent.includes(' AND ') ||
                textContent.includes(',')
              ) {
                continue;
              }
            }
            sceneHeadingText = textContent.trim();
            isSceneHeading = true;
            break;
          }
        }
      }

      if (isSceneHeading) {
        const sceneContentNodes = [currentNode];
        let sceneEndIndex = i + 1;

        while (sceneEndIndex < tree.children.length) {
          const nextNode = tree.children[sceneEndIndex];
          let isNextNodeSceneHeading = false;

          if (isParagraph(nextNode)) {
            const nextNodeText = getNodeTextContent(nextNode);
            for (const pattern of sceneHeadingPatterns) {
              if (pattern.toString().includes('[A-Z0-9]{2,}')) {
                if (
                  nextNodeText.length < 3 ||
                  nextNodeText.includes(' AND ') ||
                  nextNodeText.includes(',')
                ) {
                  continue;
                }
              }
              if (pattern.test(nextNodeText)) {
                isNextNodeSceneHeading = true;
                break;
              }
            }
          }

          if (isNextNodeSceneHeading) {
            break;
          }
          sceneContentNodes.push(nextNode);
          sceneEndIndex++;
        }

        newChildren.push({
          type: 'scene',
          data: {
            hName: 'div',
            hProperties: {
              'data-fountain-scene': 'true',
              'data-scene-heading-text': sceneHeadingText
            }
          },
          children: sceneContentNodes
        });

        i = sceneEndIndex;
      } else {
        newChildren.push(currentNode);
        i++;
      }
    }

    tree.children = newChildren;
  };
}
